import React, { useState, useEffect } from "react";
import useApiStable from "../utils/useApiStable";
import MatchBooking from "./MatchBooking"; // Importieren

const MatchScheduler = ({
  players = [],
  onScheduled,
  onScheduleMatch,
  groupId,
  initialPlayer1,
  initialPlayer2,
  reloadMatches,
}) => {
  const api = useApiStable();
  const [player1Id, setPlayer1Id] = useState("");
  const [player2Id, setPlayer2Id] = useState("");
  const [showBooking, setShowBooking] = useState(false);
  const [tournamentCourtGroupId, setTournamentCourtGroupId] = useState(null);
  const [tournamentName, setTournamentName] = useState(null);

  const getParticipantName = (participant) => {
    if (!participant) return "";
    if (participant.displayName) return participant.displayName;
    if (participant.name) return participant.name;
    if (Array.isArray(participant.players) && participant.players.length > 0) {
      return participant.players.map((player) => player.name).join(" / ");
    }
    return `Team ${participant.id}`;
  };

  useEffect(() => {
    setPlayer1Id(initialPlayer1 ? initialPlayer1.id : "");
    setPlayer2Id(initialPlayer2 ? initialPlayer2.id : "");
  }, [initialPlayer1, initialPlayer2]);

  useEffect(() => {
    if (!groupId) return;
    // Turnierinfo zur Gruppe laden (CourtGroup erzwingen)
    api
      .get(`/tournaments/groups/${groupId}`)
      .then((group) => {
        const tournament = group?.tournament;
        setTournamentCourtGroupId(tournament?.courtGroupId || null);
        setTournamentName(tournament?.name || null);
      })
      .catch(() => {
        setTournamentCourtGroupId(null);
        setTournamentName(null);
      });
  }, [api, groupId]);

  const handleContinue = () => {
    if (!player1Id || !player2Id || player1Id === player2Id) {
      alert("Bitte zwei verschiedene Teams auswählen.");
      return;
    }
    setShowBooking(true);
  };

  const handleSchedule = (slot) => {
    if (!slot) {
      setShowBooking(false);
      return;
    }

    api
      .post("/tournaments/matches", {
        team1Id: Number(player1Id),
        team2Id: Number(player2Id),
        startTime: slot.start,
        endTime: slot.end,
        courtId: slot.courtId,
        groupId: groupId,
      })
      .then((newMatch) => {
        if (onScheduleMatch) onScheduleMatch(newMatch);
        if (typeof onScheduled === "function") onScheduled();
        setShowBooking(false);
      })
      .catch((err) => alert("Fehler beim Anlegen des Spiels: " + err.message));
    if (typeof reloadMatches === "function") reloadMatches();
  };

  if (showBooking) {
    return (
      <MatchBooking
        onMatchSlotConfirm={handleSchedule}
        onCancel={() => setShowBooking(false)}
        tournamentCourtGroupId={tournamentCourtGroupId}
        tournamentName={tournamentName}
      />
    );
  }

  return (
    <div>
      <h2>Match planen</h2>
      <div
        style={{
          display: "flex",
          gap: 24,
          alignItems: "center",
          marginBottom: 18,
        }}
      >
        <div style={{ flex: 1 }}>
          {initialPlayer1 ? (
            <div className="groupphase-playerbox groupphase-playerbox-1">
              {getParticipantName(initialPlayer1)}
            </div>
          ) : (
            <select
              name="player1"
              value={player1Id}
              onChange={(e) => setPlayer1Id(e.target.value)}
              className="groupphase-select"
            >
              <option value="">Team 1 auswählen</option>
              {players.map((player) => (
                <option key={player.id} value={player.id}>
                  {getParticipantName(player)}
                </option>
              ))}
            </select>
          )}
        </div>
        <div style={{ fontWeight: 700, fontSize: 22, color: "#1976d2" }}>
          vs.
        </div>
        <div style={{ flex: 1 }}>
          {initialPlayer2 ? (
            <div className="groupphase-playerbox groupphase-playerbox-2">
              {getParticipantName(initialPlayer2)}
            </div>
          ) : (
            <select
              name="player2"
              value={player2Id}
              onChange={(e) => setPlayer2Id(e.target.value)}
              className="groupphase-select"
            >
              <option value="">Team 2 auswählen</option>
              {players.map((player) => (
                <option key={player.id} value={player.id}>
                  {getParticipantName(player)}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <button type="button" className="groupphase-button" onClick={handleContinue}>
        Zeit & Platz auswählen
      </button>
    </div>
  );
};

export default MatchScheduler;
